import styles from './HideoutLamp.module.css';

/**
 * The hideout's corner of the table (ART_BIBLE §8): a lamp on a cord with a barely visible sway,
 * its warm cone of light, and a cigarette in an ashtray with a thread of smoke. Decorative.
 */
export function HideoutLamp() {
  return (
    <div className={styles['scene']} aria-hidden="true">
      <svg className={styles['svg']} viewBox="0 0 400 120" focusable="false">
        <defs>
          <linearGradient id="hl-cone" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0" stopColor="var(--c-lamp)" stopOpacity="0.55" />
            <stop offset="1" stopColor="var(--c-lamp)" stopOpacity="0" />
          </linearGradient>
          <radialGradient id="hl-bulb">
            <stop offset="0" stopColor="#fff6d0" />
            <stop offset="0.4" stopColor="var(--c-lamp)" stopOpacity="0.7" />
            <stop offset="1" stopColor="var(--c-lamp)" stopOpacity="0" />
          </radialGradient>
          <linearGradient id="hl-table" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0" stopColor="#4a3426" />
            <stop offset="1" stopColor="#1f150f" />
          </linearGradient>
        </defs>
        <g className={styles['lamp']}>
          <polygon points="150,58 250,58 330,120 70,120" fill="url(#hl-cone)" />
          <line x1="200" y1="0" x2="200" y2="30" stroke="#0a0a14" strokeWidth="2" />
          <path
            d="M172 52 Q200 24 228 52 Z"
            fill="#1f4a3a"
            stroke="var(--c-brass)"
            strokeWidth="2"
            strokeLinejoin="round"
          />
          <rect x="196" y="28" width="8" height="6" fill="var(--c-brass-dark)" />
          <circle className={styles['bulb']} cx="200" cy="56" r="20" fill="url(#hl-bulb)" />
          <circle cx="200" cy="55" r="4" fill="#fff6d0" />
        </g>
        <rect x="0" y="100" width="400" height="20" fill="url(#hl-table)" />
        <rect x="0" y="100" width="400" height="2" fill="var(--c-brass)" opacity="0.5" />
        <g transform="translate(268 100)">
          <ellipse cx="0" cy="0" rx="22" ry="5" fill="#2a2f3a" stroke="#6a7280" />
          <rect
            x="-18"
            y="-3"
            width="26"
            height="3"
            rx="1.5"
            fill="#e8e0cc"
            transform="rotate(-8)"
          />
          <circle cx="8" cy="-4" r="1.6" fill="var(--c-neon-amber)" />
          <g className={styles['smoke']}>
            <path d="M8 -6 c-5 -9 6 -15 0 -26 c-5 -9 5 -14 1 -22" />
            <path className={styles['b']} d="M8 -6 c6 -8 -4 -15 1 -24 c4 -8 -4 -13 0 -20" />
            <path className={styles['c']} d="M8 -6 c-3 -10 5 -14 -1 -22 c-4 -8 4 -12 2 -18" />
          </g>
        </g>
        <g transform="translate(104 98) rotate(-9)">
          <rect x="-9" y="-12" width="18" height="12" rx="1.5" fill="#f3efe6" stroke="#a89f8a" />
          <rect x="-4" y="-14" width="18" height="12" rx="1.5" fill="#f3efe6" stroke="#a89f8a" />
          <path d="M5 -10 l3 3 l-3 3 l-3 -3 z" fill="var(--c-danger)" />
        </g>
        <g transform="translate(150 99)">
          <ellipse cx="0" cy="0" rx="10" ry="3" fill="var(--c-danger)" />
          <ellipse cx="0" cy="-3" rx="10" ry="3" fill="var(--c-neon-cyan)" />
          <ellipse cx="0" cy="-6" rx="10" ry="3" fill="var(--c-brass)" />
        </g>
      </svg>
    </div>
  );
}
